import React from 'react';
import {Form} from 'react-form';
import RadioButton from "./Radio";
import ApplePayButton from "./ApplePayButton";
import {ReCaptcha} from 'react-recaptcha-google';
import axios from 'axios';
import {formatPrice, i18n, validateEmail, validateFields} from '../utils';
import {Button, Col, Label, Row} from 'reactstrap';
import {Field} from '@geopagos/gp-forms';
import FormHeader from './FormHeader';
import {get} from 'lodash';
import {PaymentStatus, performPayment} from './PaymentApi';
import {
  CODE_300_TEST_CARD_NUMBER,
  PAYMENT_TYPE_CARD,
  PAYMENT_TYPE_POINTS,
  POINTS_CHECK_ERROR_CARD,
  POINTS_CHECK_ERROR_CATEGORY,
  POINTS_CHECK_ERROR_OTHER
} from '../constants';
import PointsCheck from './PointsCheck';
import Alert, {AlertType} from './Alert';
import PaymentMethodDropDown from "./PaymentMethodDropDown";

i18n.initialize();

const encodeCardNumber = cardNumber => {
  const len = cardNumber && cardNumber.length
  return cardNumber && cardNumber.substring(0, 6)
    + 'XXXXXXX'.substring(0, len - 10)
    + cardNumber.substring(len - 4, len)
}

const getExp = (month, year) => {
  return month && year && month.substring(0, 2) + year.substring(0, 2)
}

class PaymentForm extends React.Component {
  componentDidMount() {
    const { order, values } = this.props;

    if (values.cardNumber && values.cardNumber == CODE_300_TEST_CARD_NUMBER) {
      window.location.assign(window.location.protocol + "//" + window.location.host + "/payment?response=3&responsetext=Invalid+processor+REFID%3A3126688985&authcode=&transactionid=&avsresponse=&cvvresponse=&orderid=&type=sale&response_code=300&username=8726814&time=1610565808&amount=200.00&hash=21ff364821bfb3dcd779b2129b6a7ae0");
    } else if (order.withSafekey) {
      this.initializeBacSecurePay(order);
    } else {
      setTimeout(() => {
        this.form && this.form.submit()
      }, 1000);
    }
  }

  initializeBacSecurePay(order) {
    const safeKeyPublicKeyElement = document.getElementById('safeKeyPublicKey');
    const safeKeyPublicKey = safeKeyPublicKeyElement && safeKeyPublicKeyElement.innerHTML;
    const safeKey = BacSecurePay;
    try {
      safeKey.Init({
        Token: order.encoded_request,
        PublicKey: safeKeyPublicKey,
        Continue: function() {
          safeKey.Pay();
        },
        callback: function (data) {
          axios.post('/safekeyPayment', {order: order, token: data.Token})
              .then((response) => {
                window.location = "/result/"+order.id;
              });
        }
      });
    } catch (e){
        window.location = '/error/' + "payment_error";
    }

  }

  getProcessorRequestUrl() {
    const { type, order } = this.props;

    if (type === PAYMENT_TYPE_POINTS) {
      return window.location.protocol + "//" + window.location.host + "/makePayment";
    } else if (order.withSafekey) {
      return "";
    } else {
      return 'https://credomatic.compassmerchantsolutions.com/api/transact.php';
    }
  }

  getValuesForProcessorRequest() {
    const { type, order } = this.props;
    let values = null;

    if (order.withSafekey) {
      let data = this.getDataForSafeKeyRequest();

      values = data && Object.keys(data).map(name => (
          data[name] && <input key={name} type="hidden" dpmp-field={name} name={name} value={data[name]}/>
      ));
    } else {
      let data = null;

      if (type === PAYMENT_TYPE_POINTS) {
        data = this.getDataForCredomaticRequest();
      } else {
        data = this.getDataForCardinalRequest();
      }

      values = data && Object.keys(data).map(name => (
          data[name] && <input key={name} type="hidden" name={name} value={data[name]}/>
      ));
    }

    return values;
  }

  getDataForSafeKeyRequest() {
    const { values } = this.props;

    return {
      CardNumber: values.cardNumber,
      CardExpMonth: values.cardMonth,
      CardExpYear: values.cardYear,
      BillingAddress1: values.userDeliveryAddress,
      Cvv: values.cardCVV,
      BillingFullName: values.userName
    }
  }

  getDataForCardinalRequest() {
    const { values, order, product } = this.props;

    return {
      type: order.type,
      key_id: order.key_id,
      hash: order.hash,
      time: order.time,
      redirect: order.redirect,
      amount: order.amount,
      tax: order.taxAmount,
      orderid: order.id,
      ccexp: getExp(values.cardMonth, values.cardYear),
      ccnumber: values.cardNumber,
      cvv: values.cardCVV,
      address: '77777',
      processor_id: order.paymentMethod,
      merchant_defined_field_1: product.token
    }
  }

  getDataForCredomaticRequest() {
    const { values, order, product, isButton, type } = this.props;

    return {
      token: order.token,
      transactionType: "POINTS",
      paymentType: type,
      invoice: order.id,
      entryMode: "M",
      cardNumber: values.cardNumber,
      expireDate: getExp(values.cardYear, values.cardMonth),
      cardCVV: values.cardCVV,
      totalAmount: product.price * order.userData.quantity || 1,
      totalPointsAmount: order.amount,
      category: order.userData.category,
      currency: product.currency,
      isButton: isButton,
      saleInformationJson: JSON.stringify({
        totalAmount: product.price * order.userData.quantity || 1,
        totalPointsAmount: order.amount,
        taxes: [
          {
            amount: 0,
            percentage: 0
          }
        ],
        discounts: [],
        items: [
          {
            productName: product.name || "Orden",
            productBackgroundColor: "",
            isCustomAmount: true,
            productPrice: product.price / order.userData.quantity || 1,
            productPointsPrice: order.amount / order.userData.quantity || 1,
            quantity: order.userData.quantity,
            totalAmount: product.price * order.userData.quantity || 1,
            totalPointsAmount: order.amount
          }
        ]
      })
    };
  }

  render() {
    return (
      <form
        id={"payment-form"}
        method="POST"
        action={ this.getProcessorRequestUrl() }
        ref={ el => this.form = el }>
        { this.getValuesForProcessorRequest() }
      </form>
    )
  }
}

const ApplePayStatus = { READY: 0, PAYMENT_IN_PROGRESS: 1, PAYMENT_SUCCESS: 2 , PAYMENT_FAILURE: 3, PAYMENT_CANCEL: 4 };

class CheckoutForm extends React.Component {

  state = {
    order: null,
    isFetching: false,
    isVerified: false,
    recaptchaError: false,
    recaptchaToken: null,
    paymentType: null,
    category: null,
    conversion: null,
    values: {},
    isCheckingAvailablePoints: false,
    availablePoints: null,
    availablePointsCheckError: null,
    termsAccepted: true,
    policiesAccepted: true,
    applePayStatus: ApplePayStatus.READY,
    applepayEnabled: false,
    showCardForm: false,
    paymentMethodId: null,
    paymentMethodError: false,
    customer: {},
  }

  constructor(props, context) {
    super(props, context);
    this.pointsMethods = props.product.paymentMethods ? props.product.paymentMethods.filter(method => method.pointsCategory !== undefined) : [];
    this.cardsMethods = props.product.paymentMethods ? props.product.paymentMethods.filter(method => method.pointsCategory === undefined) : [];
    this.hasPointsMethod = this.pointsMethods.length > 0;
    this.hasCardsMethod = this.cardsMethods.length > 0;
  }

  componentDidMount() {
    const { product, privacyPolicies } = this.props;
    let termsAccepted = true;
    if (product.doc !== null) {
      termsAccepted = false;
    }
    if (this.captchaDemo) {
      this.setState({isVerified: false, recaptchaError: false, recaptchaToken: false, termsAccepted: termsAccepted});
      this.captchaDemo.reset();
    } else if (!this.props.recaptchaEnabled) {
        this.setState({isVerified: true, termsAccepted: termsAccepted});
    }
    if (privacyPolicies && privacyPolicies.caption) {
      this.setState({
        policiesAccepted: false
      });
    }
    if(product.customer && Object.keys(product.customer).length > 0){
      this.setState({values: {
          "userName": product.customer.fullName,
          "userEmail": product.customer.email,
          "userDocument": product.customer.document,
          "userDeliveryAddress": product.customer.address
      }})
    }
  }

  getValidations() {
    return [
      {field: 'userName', test: v => v, error: i18n.t('required')},
      {field: 'userEmail', test: v => validateEmail(v), error: i18n.t('validation_email')},
      {field: 'cardNumber', test: v => v && v.length >= 15, error: i18n.t('validation_card_number')},
      {field: 'cardMonth', test: v => (v && v.length === 2 && v <= 12 && v !== '00'), error: i18n.t('validation_month')},
      {field: 'cardYear', test: v => (v && v.length === 2), error: i18n.t('validation_year')},
      {field: 'cardCVV', test: v => (v && v.length >= 3 && v !== '000' && v !== '999' && v !== '0000' && v !== '9999'), error: i18n.t('validation_cvv')},
      {field: 'userDocument', test: v => v && v.length >= 6 && v.length <= 30, error: i18n.t('validation_document')},
    ];
  }

  onLoadRecaptcha() {
    if (this.captchaDemo) {
      this.setState({isVerified: false, recaptchaError: false});
      this.captchaDemo.reset();
    }
  }

  verifyCallback(recaptchaToken) {
    if (!this.state.isFetching) {
      this.setState({
        isFetching: false,
        recaptchaToken: recaptchaToken,
        isVerified: true,
        recaptchaError: false
      });
    }
  }

  recaptchaExpired() {
    this.setState({isVerified: false});
  }

  requestOrder(token, values) {
    if (!this.state.isFetching) {
      this.setState({isFetching: true});
      
      axios.post('/purchase/order/' + token, values)
        .then(response => {
          if(response.data["code"] == 403 || response.data["code"] == 401) {
            window.location = '/error/' + response.data["error"];
          }
          
          this.setState({
            order: {
              ...get(response, 'data.order'),
              paymentMethods: get(response, 'data.paymentMethods'),
              redirect: get(response, 'data.redirect'),
              withSafekey: get(response, 'data.order.userData.withSafeKey')
            },
            isFetching: false,
          })
        })
        .catch(error => {
          this.setState({
            order: null,
            isFetching: false,
          })
        })
    }
  }

  handleSubmit(values) {
    if (this.state.paymentMethodId === null) {
      this.setState({paymentMethodError: true});
      return ;
    }

    if (this.state.isVerified) {
      const {product, quantity} = this.props;
      const {type} = product;
      const {userName, userEmail, userDeliveryAddress, cardNumber, userDocument, cardYear, cardMonth} = values;
      const {paymentType, recaptchaToken} = this.state;

      this.requestOrder(product.token, {
        userName, userEmail, userDeliveryAddress,
        paymentType, paymentMethod: this.state.paymentMethodId, category: this.state.category, quantity, cardYear, cardMonth,
        cardNumber: encodeCardNumber(cardNumber), type, userDocument, recaptchaToken,
      });
    } else {
      this.setState({recaptchaError: true});
    }
  }

  handleFormChange(event)  {
    this.setState({
      values: event.values,
      applePayStatus: ApplePayStatus.READY
    });
  }

  handlePaymentMethodChange(item) {
    const { onChangePaymentMethod } = this.props;

    this.setState({
      paymentMethodId: item.value,
      category: item.category,
      conversion: item.conversion,
      applepayEnabled: item.applepayEnabled
    });

    onChangePaymentMethod(this.state.paymentType, item.conversion);
  }

  handleFormAppleChange(event)  {
    this.setState({
      values: event.values,
    });
  }

  handlePaymentTypeChange = (event) => {
    const { onChangePaymentMethod } = this.props;

    this.setState({
      paymentMethodId: null,
      category: null,
      paymentType: event.target.value,
      availablePoints: (event.target.value === PAYMENT_TYPE_POINTS) ? this.state.availablePoints : null
    });

    onChangePaymentMethod(event.target.value);
  }

  getTotalAmount() {
    const { product, quantity } = this.props;

    if (this.state.paymentType === PAYMENT_TYPE_POINTS) {
      if (this.state.conversion) {
        return i18n.t('pay') + " " + Math.ceil((product.price * quantity) / this.state.conversion) + " " + i18n.t('points');
      } else {
        return i18n.t('points_choose_loyalty');
      }
    } else {
      return i18n.t('pay') + " " + formatPrice(product.price * quantity, product.currencySymbol);
    }
  }

  getPaymentMethods() {
    if (this.state.paymentType == null) {
      if (this.hasPointsMethod && !this.hasCardsMethod) {
        this.setState({paymentType: PAYMENT_TYPE_POINTS});
      } else {
        this.setState({paymentType: PAYMENT_TYPE_CARD});
      }
    }

    return this.state.paymentType === PAYMENT_TYPE_POINTS ? this.pointsMethods : this.cardsMethods;
  }

  validCardValues = (values) => {
    const { cardNumber, cardMonth, cardYear, cardCVV } = values;

    if (cardNumber == null || cardNumber.length < 15) {
      return false;
    }

    if (cardMonth == null || cardMonth.length !== 2 || cardMonth > 12) {
      return false;
    }

    if (cardYear == null || cardYear.length !== 2) {
      return false;
    }

    return !(cardCVV == null || cardCVV.length < 3);
  }

  pointsCheckHandler = () => {
    const { product } = this.props;
    const { values, category } = this.state;
    let availablePoints = null;
    let availablePointsCheckError = null;

    if (!this.validCardValues(values)) {
      this.setState({
        isCheckingAvailablePoints: false,
        availablePoints: null,
        availablePointsCheckError: POINTS_CHECK_ERROR_CARD
      });
    } else if (category == null) {
      this.setState({
        isCheckingAvailablePoints: false,
        availablePoints: null,
        availablePointsCheckError: POINTS_CHECK_ERROR_CATEGORY
      });
    } else {
      this.setState({isCheckingAvailablePoints: true});

      axios.post('/queryAvailablePoints', {token: product.token, values: values, category: category})
          .then(response => {
            availablePoints = null;
            if (response.data.error || response.data.executeTransactionResult.responseCode != "00") {
              availablePointsCheckError = POINTS_CHECK_ERROR_OTHER;
            } else {
              availablePointsCheckError = null;
              availablePoints = parseInt(response.data.executeTransactionResult.salesAmount);
            }

            this.setState({
              isCheckingAvailablePoints: false,
              availablePoints: availablePoints,
              availablePointsCheckError: availablePointsCheckError
            });
          })
          .catch(error => {
            this.setState({
              isCheckingAvailablePoints: false,
              availablePoints: null,
              availablePointsCheckError: POINTS_CHECK_ERROR_OTHER
            });
          })
    }
  }

  validateAlphanumeric(e) {
    if(/[^a-zA-Z0-9]+$/.test(e.key)) e.preventDefault();
  }

  validateNumbers(e) {
    if(!/^\d+$/.test(e.key)) e.preventDefault();
  }

  validateNumbersOnPaste(e) {
    const re = /^[0-9\b]+$/;
    let text = e.clipboardData.getData('Text');
    if(!(text === '' || re.test(text))) {
      e.preventDefault();
      return false;
    }
  }

  validateNumbersOnDrop(e) {
    const re = /^[0-9\b]+$/;
    let text = e.dataTransfer.getData('Text');
    if(!(text === '' || re.test(text))) {
      e.preventDefault();
      return false;
    }
  }

  appleClick() {
    this.setState({
      applePayStatus: ApplePayStatus.PAYMENT_IN_PROGRESS
    });
    const { product, quantity} = this.props;

    performPayment(product, quantity, this.state.paymentMethodId, null)
        .then( (paymentStatus) => {
          switch (paymentStatus) {
            case PaymentStatus.CANCEL:
              this.setState({applePayStatus: ApplePayStatus.PAYMENT_CANCEL});
              break;
            case PaymentStatus.SUCCESS:
              this.setState({applePayStatus: ApplePayStatus.PAYMENT_SUCCESS});
              break;
            default:
              this.setState({applePayStatus: ApplePayStatus.PAYMENT_FAILURE});
          }
        })
        .catch( (err) => {
          this.setState({applePayStatus: ApplePayStatus.PAYMENT_FAILURE});
        })
  }

  cardFormClick() {
    this.setState({
      showCardForm: !this.state.showCardForm
    });
  }

  render() {
    const {product, recaptchaEnabled, recaptchaPublicKey, isButton, privacyPolicies} = this.props;
    i18n.changeLanguage(localStorage.getItem('productLanguage'));

    const {order, isFetching, values, recaptchaError, showCardForm, paymentMethodError} = this.state;
    const processing = !!(order || isFetching);
    const totalAmount = this.getTotalAmount();
    const paymentMethods = this.getPaymentMethods();

    const alertMessage = () => {
      switch (this.state.applePayStatus) {
        case ApplePayStatus.PAYMENT_IN_PROGRESS:
          return (
              <Alert text="Procesando pago..." type={AlertType.INFO} spinner={true}/>
          )
        case ApplePayStatus.PAYMENT_SUCCESS:
          return (
              <div></div>
          )
        case ApplePayStatus.PAYMENT_CANCEL:
          this.setState({
            applePayStatus: ApplePayStatus.READY
          });
          return null;
        case ApplePayStatus.PAYMENT_FAILURE:
          return (
              <Alert text="Pago fallido" type={AlertType.ERROR}/>
          )
        default:
          return null;
      }
    };

    const AppleButton = this.state.paymentType !== PAYMENT_TYPE_POINTS && this.state.applePayStatus === ApplePayStatus.READY && this.state.applepayEnabled && window.ApplePaySession && (
        <ApplePayButton
            onClick={this.appleClick.bind(this)}
            disabled={processing || (product.doc && !this.state.termsAccepted) || !this.state.policiesAccepted || this.state.showCardForm}
        />
    );

    const CardButton = this.state.applePayStatus === ApplePayStatus.READY && this.state.applepayEnabled && (
        <div className="apple-container" lang="es">
          <div
                  className="card-pay-button btn btn-primary btn-block"
                  color="primary"
                  onClick={this.cardFormClick.bind(this)}
          >
            {(showCardForm && this.state.applePayStatus !== ApplePayStatus.READY) ? 'Pagar con apple pay' : 'Pagar con tarjeta'}
          </div>
        </div>
    );

    const DropDown = (
        <PaymentMethodDropDown
            i18n = { i18n }
            paymentType = {this.state.paymentType}
            hasPointsMethod = { this.hasPointsMethod }
            hasCardsMethod = { this.hasCardsMethod }
            paymentMethods = { paymentMethods }
            onPaymentMethodChange = { this.handlePaymentMethodChange.bind(this) }
            selectedPaymentMethod = { this.state.paymentMethodId }
        />
    )

    const terms =product.doc !== null && (
        <div className="custom-control custom-checkbox terms-and-conditions">
              <input
                  type="checkbox"
                  id="terms"
                  className="custom-control-input"
                  checked={this.state.termsAccepted}
                  onChange={(e) => { this.setState({ termsAccepted: e.target.checked }) }}
              />
              <label htmlFor="terms" className="custom-control-label">
                { i18n.t('i_accept_the')}
                {" "}
                <a href={product.doc}>{ i18n.t('terms_and_conditions') }.</a>
              </label>
            </div>
    )

    const policies = privacyPolicies.caption !== null &&(
        <div className="custom-control custom-checkbox terms-and-conditions">
              <input
                  type="checkbox"
                  id="PAC"
                  className="custom-control-input"
                  checked={this.state.policiesAccepted}
                  onChange={(e) => { this.setState({ policiesAccepted: e.target.checked }) }}
              />
              <label htmlFor="PAC" className="custom-control-label">
                { privacyPolicies.caption }
                {" "}
                { (privacyPolicies.link !== null) && (<a target={"_blank"} href={privacyPolicies.link}>{ i18n.t('privacy_policy') }</a>) }
              </label>
            </div>
    )

    return (
        <div>
          <div className="checkout-form">
            { DropDown }
            <Form onChange={ this.handleFormAppleChange.bind(this) } >
              { terms }
              { policies }
            </Form>
            { alertMessage() }
            { AppleButton }
            { CardButton }
          </div>
          {(paymentMethodError) && <Label className="text-primary">{i18n.t('payment_method_required')}</Label> }

          { (this.state.showCardForm || (this.state.paymentMethodId && !this.state.applepayEnabled)) && (
            <Form
              onSubmit={this.handleSubmit.bind(this)}
              onChange={ this.handleFormChange.bind(this) }
              values={values}
              validate={validateFields(this.getValidations())}
            >
            {formApi => (
                <div className="checkout-form" style={{marginTop: 30}}>
                  {order && <PaymentForm type={this.state.paymentType} values={values} order={order} product={product} isButton={isButton} /> }
                  <FormHeader cardsImage={product.checkoutCardsImage}/>
                  <div className="checkout-form-content">
                    <div className="radio-group">
                      {(this.hasPointsMethod && this.hasCardsMethod) && (
                          <div>
                            <h2 className="font-weight-bold">{ i18n.t("how_will_you_pay") }</h2>
                            <RadioButton
                                changed={ this.handlePaymentTypeChange }
                                id="1"
                                isSelected={ this.state.paymentType === PAYMENT_TYPE_CARD }
                                label={ i18n.t("credit_debit_card") }
                                value= { PAYMENT_TYPE_CARD }
                                disabled={false}
                            />
                            <RadioButton
                                changed={ this.handlePaymentTypeChange }
                                id="2"
                                isSelected={ this.state.paymentType === PAYMENT_TYPE_POINTS }
                                label={ i18n.t("points") }
                                value= { PAYMENT_TYPE_POINTS }
                                disabled={false}
                            />
                          </div>
                      )}
                    </div>

                    <Field
                        id="cardNumber"
                        name="ccnumber"
                        field="cardNumber"
                        placeholder={ i18n.t("enter_your_card_number") }
                        maxLength={16}
                        onKeyPress={this.validateNumbers.bind(this)}
                        onPaste={this.validateNumbersOnPaste}
                        onDrop={this.validateNumbersOnDrop}
                    />

                    <label>{ i18n.t('expiration') }</label>
                    <Row>
                      <Col sm="3" xs="12">
                        <Field
                            id="cardMonth"
                            name="cardMonth"
                            field="cardMonth"
                            placeholder={ i18n.t("card_mm") }
                            maxLength={2}
                            type="text"
                            onKeyPress={this.validateNumbers.bind(this)}
                            onPaste={this.validateNumbersOnPaste}
                            onDrop={this.validateNumbersOnDrop}
                        />
                      </Col>
                      <Col sm="3" xs="12">
                        <Field
                            id="cardYear"
                            name="cardYear"
                            field="cardYear"
                            placeholder={ i18n.t("card_yy") }
                            maxLength={2}
                            type="text"
                            onKeyPress={this.validateNumbers.bind(this)}
                            onPaste={this.validateNumbersOnPaste}
                            onDrop={this.validateNumbersOnDrop}
                        />
                      </Col>
                      <Col sm="3" xs="12">
                        <Field
                            id="cardCsc"
                            name="cvv"
                            field="cardCVV"
                            placeholder={ i18n.t("card_cvv") }
                            maxLength={4}
                            onKeyPress={this.validateNumbers.bind(this)}
                            onPaste={this.validateNumbersOnPaste}
                            onDrop={this.validateNumbersOnDrop}
                            type="password"
                        />
                      </Col>
                    </Row>

                    <h2 className="font-weight-bold">{ i18n.t("fill_your_data") }</h2>
                    <Field
                        id="cardName"
                        field="userName"
                        placeholder={ i18n.t("full_name_fill") } />
                    <Field
                        id="email"
                        field="userEmail"
                        placeholder={ i18n.t("email_fill") } />
                    <Field
                        id="userDocument"
                        field="userDocument"
                        placeholder={ i18n.t("document_fill") }
                        onKeyPress={this.validateAlphanumeric.bind(this)}
                        maxLength={30}
                    />
                    <Field
                        id="deliveryAddress"
                        field="userDeliveryAddress"
                        placeholder={ i18n.t("shipping_address_fill") }
                        help={ i18n.t('shipping_address_help') }
                    />

                    {(recaptchaEnabled && recaptchaError)
                        && <Label className="text-primary">{i18n.t('captcha_is_incorrect')}</Label> }
                    {recaptchaEnabled && (
                        <div className="form-group">
                          <ReCaptcha
                              ref={(el) => { this.captchaDemo = el; }}
                              hl={product.language}
                              size="normal"
                              render="explicit"
                              sitekey={recaptchaPublicKey}
                              onloadCallback={this.onLoadRecaptcha.bind(this)}
                              verifyCallback={this.verifyCallback.bind(this)}
                              expiredCallback={this.recaptchaExpired.bind(this)}
                          />
                        </div>
                    )}

                    {(this.state.paymentType === PAYMENT_TYPE_POINTS || (this.hasPointsMethod && !this.hasCardsMethod)) && (
                        <PointsCheck
                            isChecking={ this.state.isCheckingAvailablePoints }
                            isVerified={ this.state.isVerified }
                            availablePoints={ this.state.availablePoints }
                            availablePointsCheckError={ this.state.availablePointsCheckError }
                            pointsCheckHandler={ this.pointsCheckHandler }
                        />
                    )}
                  </div>

                  <div className="checkout-form-footer">
                    <Button
                        block
                        className="btn-pay"
                        color="primary"
                        disabled={processing || (this.state.paymentType === PAYMENT_TYPE_POINTS && !this.state.conversion) ||
                            !this.state.paymentMethodId || (product.doc && !this.state.termsAccepted) || !this.state.policiesAccepted}
                        onClick={() => formApi.submitForm()}
                    >
                      { processing ? i18n.t('proccesing_payment') : `${totalAmount}` }
                    </Button>
                  </div>

                </div>
            )}

          </Form>)}

        </div>
    );
  }
}

export default CheckoutForm;



// WEBPACK FOOTER //
// ./client/components/CheckoutForm.js